export interface Permission {
  id: number;
  name: string;
  displayName: string;
  displayNameKey?: string;
  description?: string;
  descriptionKey?: string;
  category: PermissionCategory;
  resource: string;
  action: PermissionAction;
  isSystemPermission: boolean;
  isActive: boolean;
  createdDate: Date;
  updatedDate: Date;
  level: number;
}

export enum PermissionCategory {
  DASHBOARD = 'dashboard',
  REQUESTS = 'requests',
  INVOICES = 'invoices',
  ANNOUNCEMENTS = 'announcements',
  CLASSIFIED_ADS = 'classified_ads',
  BOOKINGS = 'bookings',
  PET_REGISTRY = 'pet_registry',
  VENDORS = 'vendors',
  RESIDENTS = 'residents',
  PROPERTIES = 'properties',
  USERS = 'users',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  NOTIFICATIONS = 'notifications',
  SUPPORT_TICKETS = 'support_tickets',
  AUDIT_LOGS = 'audit_logs',
  SETTINGS = 'settings',
  REPORTS = 'reports',
  SYSTEM = 'system',
}

export enum PermissionAction {
  CREATE = 'create',
  READ = 'read',
  UPDATE = 'update',
  DELETE = 'delete',
  APPROVE = 'approve',
  REJECT = 'reject',
  ASSIGN = 'assign',
  UNASSIGN = 'unassign',
  EXPORT = 'export',
  IMPORT = 'import',
  MANAGE = 'manage',
  VIEW_ALL = 'view_all',
  EDIT_ALL = 'edit_all',
  DELETE_ALL = 'delete_all',
}

export interface PermissionGroup {
  id: number;
  name: string;
  displayName: string;
  description?: string;
  category: PermissionCategory;
  permissions: Permission[];
  isActive: boolean;
  createdDate: Date;
  updatedDate: Date;
}

export interface UserPermission {
  id: number;
  userId: number;
  permissionId: number;
  grantedDate: Date;
  grantedBy: number;
  expiresDate?: Date;
  isActive: boolean;
  reason?: string;
}

export interface PermissionTemplate {
  id: number;
  name: string;
  description?: string;
  roleId: number;
  permissions: number[];
  isActive: boolean;
  createdDate: Date;
  updatedDate: Date;
}
